"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.percentage = void 0;
/**
 * Calculate the percentage of the rail that has been scrolled.
 * If the left edge is at the total minus the viewport we are done scrolling.
 * @param viewport window width
 * @param total total width of the rail
 * @param left left edge of scroll
 */

var percentage = function percentage(_ref) {
  var viewport = _ref.viewport,
      total = _ref.total,
      left = _ref.left;
  return Math.round(left / (total - viewport) * 100);
};

exports.percentage = percentage;